import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setDatiIdentificativiIndirizziListeners } from './dati-identificativi-indirizzi.listeners';
import { setDatiIdentificativiMutualitaEnteListeners } from './dati-identificativi-mutualita-ente.listeners';
import { setDatiIdentificativiSocietaRappresentanteListeners } from './dati-identificativi-societa-rappresentante.listeners';
import { setDatiIdentificativiCalcoliListeners } from './dati-identificativi-calcoli.listeners';

export class DatiIdentificativiFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;
    private readonly toastrService: ToastrService;

    constructor(form: FormGroup, store: Store<Revisione53State>, toastrService: ToastrService) {
        super(form);
        this.store = store;
        this.toastrService = toastrService;
    }

    setListeners(): void {
        setDatiIdentificativiIndirizziListeners(this.form, this.store);
        setDatiIdentificativiMutualitaEnteListeners(this.form, this.store, this.toastrService);
        setDatiIdentificativiSocietaRappresentanteListeners(this.form, this.store, this.toastrService);
        setDatiIdentificativiCalcoliListeners(this.form, this.store);
    }
}
